import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	BlockControls,
	AlignmentToolbar,
	InspectorControls,
	MediaUpload,
} from '@wordpress/block-editor';
import {
	PanelBody,
	ToggleControl,
	Button,
	ComboboxControl,
	
} from '@wordpress/components';
import { useState } from '@wordpress/element';

const { SelectControl, TextControl } = wp.components;
import classnames from 'classnames';
import './editor.scss';

const agentImage = require('./image/user.jpg');

const timezones = [
	{
		value: 'Africa/Abidjan',
		label: __('Africa/Abidjan', 'chat-viber'),
	},
	{
		value: 'Africa/Accra',
		label: __('Africa/Accra', 'chat-viber'),
	},
	{
		value: 'Africa/Addis_Ababa',
		label: __('Africa/Addis_Ababa', 'chat-viber'),
	},
	{
		value: 'Africa/Algiers',
		label: __('Africa/Algiers', 'chat-viber'),
	},
	{
		value: 'Africa/Asmara',
		label: __('Africa/Asmara', 'chat-viber'),
	},
	{
		value: 'Africa/Asmera',
		label: __('Africa/Asmera', 'chat-viber'),
	},
	{
		value: 'Africa/Bamako',
		label: __('Africa/Bamako', 'chat-viber'),
	},
	{
		value: 'Africa/Bangui',
		label: __('Africa/Bangui', 'chat-viber'),
	},
	{
		value: 'Africa/Banjul',
		label: __('Africa/Banjul', 'chat-viber'),
	},
	{
		value: 'Africa/Bissau',
		label: __('Africa/Bissau', 'chat-viber'),
	},
	{
		value: 'Africa/Blantyre',
		label: __('Africa/Blantyre', 'chat-viber'),
	},
	{
		value: 'Africa/Brazzaville',
		label: __('Africa/Brazzaville', 'chat-viber'),
	},
	{
		value: 'Africa/Bujumbura',
		label: __('Africa/Bujumbura', 'chat-viber'),
	},
	{
		value: 'Africa/Cairo',
		label: __('Africa/Cairo', 'chat-viber'),
	},
	{
		value: 'Africa/Casablanca',
		label: __('Africa/Casablanca', 'chat-viber'),
	},
	{
		value: 'Africa/Ceuta',
		label: __('Africa/Ceuta', 'chat-viber'),
	},
	{
		value: 'Africa/Conakry',
		label: __('Africa/Conakry', 'chat-viber'),
	},
	{
		value: 'Africa/Dakar',
		label: __('Africa/Dakar', 'chat-viber'),
	},
	{
		value: 'Africa/Dar_es_Salaam',
		label: __('Africa/Dar_es_Salaam', 'chat-viber'),
	},
	{
		value: 'Africa/Djibouti',
		label: __('Africa/Djibouti', 'chat-viber'),
	},
	{
		value: 'Africa/Douala',
		label: __('Africa/Douala', 'chat-viber'),
	},
	{
		value: 'Africa/El_Aaiun',
		label: __('Africa/El_Aaiun', 'chat-viber'),
	},
	{
		value: 'Africa/Freetown',
		label: __('Africa/Freetown', 'chat-viber'),
	},
	{
		value: 'Africa/Gaborone',
		label: __('Africa/Gaborone', 'chat-viber'),
	},
	{
		value: 'Africa/Harare',
		label: __('Africa/Harare', 'chat-viber'),
	},
	{
		value: 'Africa/Johannesburg',
		label: __('Africa/Johannesburg', 'chat-viber'),
	},
	{
		value: 'Africa/Juba',
		label: __('Africa/Juba', 'chat-viber'),
	},
	{
		value: 'Africa/Kampala',
		label: __('Africa/Kampala', 'chat-viber'),
	},
	{
		value: 'Africa/Khartoum',
		label: __('Africa/Khartoum', 'chat-viber'),
	},
	{
		value: 'Africa/Kigali',
		label: __('Africa/Kigali', 'chat-viber'),
	},
	{
		value: 'Africa/Kinshasa',
		label: __('Africa/Kinshasa', 'chat-viber'),
	},
	{
		value: 'Africa/Lagos',
		label: __('Africa/Lagos', 'chat-viber'),
	},
	{
		value: 'Africa/Libreville',
		label: __('Africa/Libreville', 'chat-viber'),
	},
	{
		value: 'Africa/Lome',
		label: __('Africa/Lome', 'chat-viber'),
	},
	{
		value: 'Africa/Luanda',
		label: __('Africa/Luanda', 'chat-viber'),
	},
	{
		value: 'Africa/Lubumbashi',
		label: __('Africa/Lubumbashi', 'chat-viber'),
	},
	{
		value: 'Africa/Lusaka',
		label: __('Africa/Lusaka', 'chat-viber'),
	},
	{
		value: 'Africa/Malabo',
		label: __('Africa/Malabo', 'chat-viber'),
	},
	{
		value: 'Africa/Maputo',
		label: __('Africa/Maputo', 'chat-viber'),
	},
	{
		value: 'Africa/Maseru',
		label: __('Africa/Maseru', 'chat-viber'),
	},
	{
		value: 'Africa/Mbabane',
		label: __('Africa/Mbabane', 'chat-viber'),
	},
	{
		value: 'Africa/Mogadishu',
		label: __('Africa/Mogadishu', 'chat-viber'),
	},
	{
		value: 'Africa/Monrovia',
		label: __('Africa/Monrovia', 'chat-viber'),
	},
	{
		value: 'Africa/Nairobi',
		label: __('Africa/Nairobi', 'chat-viber'),
	},
	{
		value: 'Africa/Ndjamena',
		label: __('Africa/Ndjamena', 'chat-viber'),
	},
	{
		value: 'Africa/Niamey',
		label: __('Africa/Niamey', 'chat-viber'),
	},
	{
		value: 'Africa/Nouakchott',
		label: __('Africa/Nouakchott', 'chat-viber'),
	},
	{
		value: 'Africa/Ouagadougou',
		label: __('Africa/Ouagadougou', 'chat-viber'),
	},
	{
		value: 'Africa/Porto-Novo',
		label: __('Africa/Porto-Novo', 'chat-viber'),
	},
	{
		value: 'Africa/Sao_Tome',
		label: __('Africa/Sao_Tome', 'chat-viber'),
	},
	{
		value: 'Africa/Timbuktu',
		label: __('Africa/Timbuktu', 'chat-viber'),
	},
	{
		value: 'Africa/Tripoli',
		label: __('Africa/Tripoli', 'chat-viber'),
	},
	{
		value: 'Africa/Tunis',
		label: __('Africa/Tunis', 'chat-viber'),
	},
	{
		value: 'Africa/Windhoek',
		label: __('Africa/Windhoek', 'chat-viber'),
	},
	{
		value: 'America/Adak',
		label: __('America/Adak', 'chat-viber'),
	},
	{
		value: 'America/Anchorage',
		label: __('America/Anchorage', 'chat-viber'),
	},
	{
		value: 'America/Anguilla',
		label: __('America/Anguilla', 'chat-viber'),
	},
	{
		value: 'America/Antigua',
		label: __('America/Antigua', 'chat-viber'),
	},
	{
		value: 'America/Araguaina',
		label: __('America/Araguaina', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Buenos_Aires',
		label: __('America/Argentina/Buenos_Aires', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Catamarca',
		label: __('America/Argentina/Catamarca', 'chat-viber'),
	},
	{
		value: 'America/Argentina/ComodRivadavia',
		label: __('America/Argentina/ComodRivadavia', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Cordoba',
		label: __('America/Argentina/Cordoba', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Jujuy',
		label: __('America/Argentina/Jujuy', 'chat-viber'),
	},
	{
		value: 'America/Argentina/La_Rioja',
		label: __('America/Argentina/La_Rioja', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Mendoza',
		label: __('America/Argentina/Mendoza', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Rio_Gallegos',
		label: __('America/Argentina/Rio_Gallegos', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Salta',
		label: __('America/Argentina/Salta', 'chat-viber'),
	},
	{
		value: 'America/Argentina/San_Juan',
		label: __('America/Argentina/San_Juan', 'chat-viber'),
	},
	{
		value: 'America/Argentina/San_Luis',
		label: __('America/Argentina/San_Luis', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Tucuman',
		label: __('America/Argentina/Tucuman', 'chat-viber'),
	},
	{
		value: 'America/Argentina/Ushuaia',
		label: __('America/Argentina/Ushuaia', 'chat-viber'),
	},
	{
		value: 'America/Aruba',
		label: __('America/Aruba', 'chat-viber'),
	},
	{
		value: 'America/Asuncion',
		label: __('America/Asuncion', 'chat-viber'),
	},
	{
		value: 'America/Atikokan',
		label: __('America/Atikokan', 'chat-viber'),
	},
	{
		value: 'America/Atka',
		label: __('America/Atka', 'chat-viber'),
	},
	{
		value: 'America/Bahia',
		label: __('America/Bahia', 'chat-viber'),
	},
	{
		value: 'America/Bahia_Banderas',
		label: __('America/Bahia_Banderas', 'chat-viber'),
	},
	{
		value: 'America/Barbados',
		label: __('America/Barbados', 'chat-viber'),
	},
	{
		value: 'America/Belem',
		label: __('America/Belem', 'chat-viber'),
	},
	{
		value: 'America/Belize',
		label: __('America/Belize', 'chat-viber'),
	},
	{
		value: 'America/Blanc-Sablon',
		label: __('America/Blanc-Sablon', 'chat-viber'),
	},
	{
		value: 'America/Boa_Vista',
		label: __('America/Boa_Vista', 'chat-viber'),
	},
	{
		value: 'America/Bogota',
		label: __('America/Bogota', 'chat-viber'),
	},
	{
		value: 'America/Boise',
		label: __('America/Boise', 'chat-viber'),
	},
	{
		value: 'America/Buenos_Aires',
		label: __('America/Buenos_Aires', 'chat-viber'),
	},
	{
		value: 'America/Cambridge_Bay',
		label: __('America/Cambridge_Bay', 'chat-viber'),
	},
	{
		value: 'America/Campo_Grande',
		label: __('America/Campo_Grande', 'chat-viber'),
	},
	{
		value: 'America/Cancun',
		label: __('America/Cancun', 'chat-viber'),
	},
	{
		value: 'America/Caracas',
		label: __('America/Caracas', 'chat-viber'),
	},
	{
		value: 'America/Catamarca',
		label: __('America/Catamarca', 'chat-viber'),
	},
	{
		value: 'America/Cayenne',
		label: __('America/Cayenne', 'chat-viber'),
	},
	{
		value: 'America/Cayman',
		label: __('America/Cayman', 'chat-viber'),
	},
	{
		value: 'America/Chicago',
		label: __('America/Chicago', 'chat-viber'),
	},
	{
		value: 'America/Chihuahua',
		label: __('America/Chihuahua', 'chat-viber'),
	},
	{
		value: 'America/Coral_Harbour',
		label: __('America/Coral_Harbour', 'chat-viber'),
	},
	{
		value: 'America/Cordoba',
		label: __('America/Cordoba', 'chat-viber'),
	},
	{
		value: 'America/Costa_Rica',
		label: __('America/Costa_Rica', 'chat-viber'),
	},
	{
		value: 'America/Creston',
		label: __('America/Creston', 'chat-viber'),
	},
	{
		value: 'America/Cuiaba',
		label: __('America/Cuiaba', 'chat-viber'),
	},
	{
		value: 'America/Curacao',
		label: __('America/Curacao', 'chat-viber'),
	},
	{
		value: 'America/Danmarkshavn',
		label: __('America/Danmarkshavn', 'chat-viber'),
	},
	{
		value: 'America/Dawson',
		label: __('America/Dawson', 'chat-viber'),
	},
	{
		value: 'America/Dawson_Creek',
		label: __('America/Dawson_Creek', 'chat-viber'),
	},
	{
		value: 'America/Denver',
		label: __('America/Denver', 'chat-viber'),
	},
	{
		value: 'America/Detroit',
		label: __('America/Detroit', 'chat-viber'),
	},
	{
		value: 'America/Dominica',
		label: __('America/Dominica', 'chat-viber'),
	},
	{
		value: 'America/Edmonton',
		label: __('America/Edmonton', 'chat-viber'),
	},
	{
		value: 'America/Eirunepe',
		label: __('America/Eirunepe', 'chat-viber'),
	},
	{
		value: 'America/El_Salvador',
		label: __('America/El_Salvador', 'chat-viber'),
	},
	{
		value: 'America/Ensenada',
		label: __('America/Ensenada', 'chat-viber'),
	},
	{
		value: 'America/Fort_Nelson',
		label: __('America/Fort_Nelson', 'chat-viber'),
	},
	{
		value: 'America/Fort_Wayne',
		label: __('America/Fort_Wayne', 'chat-viber'),
	},
	{
		value: 'America/Fortaleza',
		label: __('America/Fortaleza', 'chat-viber'),
	},
	{
		value: 'America/Glace_Bay',
		label: __('America/Glace_Bay', 'chat-viber'),
	},
	{
		value: 'America/Godthab',
		label: __('America/Godthab', 'chat-viber'),
	},
	{
		value: 'America/Goose_Bay',
		label: __('America/Goose_Bay', 'chat-viber'),
	},
	{
		value: 'America/Grand_Turk',
		label: __('America/Grand_Turk', 'chat-viber'),
	},
	{
		value: 'America/Grenada',
		label: __('America/Grenada', 'chat-viber'),
	},
	{
		value: 'America/Guadeloupe',
		label: __('America/Guadeloupe', 'chat-viber'),
	},
	{
		value: 'America/Guatemala',
		label: __('America/Guatemala', 'chat-viber'),
	},
	{
		value: 'America/Guayaquil',
		label: __('America/Guayaquil', 'chat-viber'),
	},
	{
		value: 'America/Guyana',
		label: __('America/Guyana', 'chat-viber'),
	},
	{
		value: 'America/Halifax',
		label: __('America/Halifax', 'chat-viber'),
	},
	{
		value: 'America/Havana',
		label: __('America/Havana', 'chat-viber'),
	},
	{
		value: 'America/Hermosillo',
		label: __('America/Hermosillo', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Indianapolis',
		label: __('America/Indiana/Indianapolis', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Knox',
		label: __('America/Indiana/Knox', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Marengo',
		label: __('America/Indiana/Marengo', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Petersburg',
		label: __('America/Indiana/Petersburg', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Tell_City',
		label: __('America/Indiana/Tell_City', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Vevay',
		label: __('America/Indiana/Vevay', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Vincennes',
		label: __('America/Indiana/Vincennes', 'chat-viber'),
	},
	{
		value: 'America/Indiana/Winamac',
		label: __('America/Indiana/Winamac', 'chat-viber'),
	},
	{
		value: 'America/Indianapolis',
		label: __('America/Indianapolis', 'chat-viber'),
	},
	{
		value: 'America/Inuvik',
		label: __('America/Inuvik', 'chat-viber'),
	},
	{
		value: 'America/Iqaluit',
		label: __('America/Iqaluit', 'chat-viber'),
	},
	{
		value: 'America/Jamaica',
		label: __('America/Jamaica', 'chat-viber'),
	},
	{
		value: 'America/Jujuy',
		label: __('America/Jujuy', 'chat-viber'),
	},
	{
		value: 'America/Juneau',
		label: __('America/Juneau', 'chat-viber'),
	},
	{
		value: 'America/Kentucky/Louisville',
		label: __('America/Kentucky/Louisville', 'chat-viber'),
	},
	{
		value: 'America/Kentucky/Monticello',
		label: __('America/Kentucky/Monticello', 'chat-viber'),
	},
	{
		value: 'America/Knox_IN',
		label: __('America/Knox_IN', 'chat-viber'),
	},
	{
		value: 'America/Kralendijk',
		label: __('America/Kralendijk', 'chat-viber'),
	},
	{
		value: 'America/La_Paz',
		label: __('America/La_Paz', 'chat-viber'),
	},
	{
		value: 'America/Lima',
		label: __('America/Lima', 'chat-viber'),
	},
	{
		value: 'America/Los_Angeles',
		label: __('America/Los_Angeles', 'chat-viber'),
	},
	{
		value: 'America/Louisville',
		label: __('America/Louisville', 'chat-viber'),
	},
	{
		value: 'America/Lower_Princes',
		label: __('America/Lower_Princes', 'chat-viber'),
	},
	{
		value: 'America/Maceio',
		label: __('America/Maceio', 'chat-viber'),
	},
	{
		value: 'America/Managua',
		label: __('America/Managua', 'chat-viber'),
	},
	{
		value: 'America/Manaus',
		label: __('America/Manaus', 'chat-viber'),
	},
	{
		value: 'America/Marigot',
		label: __('America/Marigot', 'chat-viber'),
	},
	{
		value: 'America/Martinique',
		label: __('America/Martinique', 'chat-viber'),
	},
	{
		value: 'America/Matamoros',
		label: __('America/Matamoros', 'chat-viber'),
	},
	{
		value: 'America/Mazatlan',
		label: __('America/Mazatlan', 'chat-viber'),
	},
	{
		value: 'America/Mendoza',
		label: __('America/Mendoza', 'chat-viber'),
	},
	{
		value: 'America/Menominee',
		label: __('America/Menominee', 'chat-viber'),
	},
	{
		value: 'America/Merida',
		label: __('America/Merida', 'chat-viber'),
	},
	{
		value: 'America/Metlakatla',
		label: __('America/Metlakatla', 'chat-viber'),
	},
	{
		value: 'America/Mexico_City',
		label: __('America/Mexico_City', 'chat-viber'),
	},
	{
		value: 'America/Miquelon',
		label: __('America/Miquelon', 'chat-viber'),
	},
	{
		value: 'America/Moncton',
		label: __('America/Moncton', 'chat-viber'),
	},
	{
		value: 'America/Monterrey',
		label: __('America/Monterrey', 'chat-viber'),
	},
	{
		value: 'America/Montevideo',
		label: __('America/Montevideo', 'chat-viber'),
	},
	{
		value: 'America/Montreal',
		label: __('America/Montreal', 'chat-viber'),
	},
	{
		value: 'America/Montserrat',
		label: __('America/Montserrat', 'chat-viber'),
	},
	{
		value: 'America/Nassau',
		label: __('America/Nassau', 'chat-viber'),
	},
	{
		value: 'America/New_York',
		label: __('America/New_York', 'chat-viber'),
	},
	{
		value: 'America/Nipigon',
		label: __('America/Nipigon', 'chat-viber'),
	},
	{
		value: 'America/Nome',
		label: __('America/Nome', 'chat-viber'),
	},
	{
		value: 'America/Noronha',
		label: __('America/Noronha', 'chat-viber'),
	},
	{
		value: 'America/North_Dakota/Beulah',
		label: __('America/North_Dakota/Beulah', 'chat-viber'),
	},
	{
		value: 'America/North_Dakota/Center',
		label: __('America/North_Dakota/Center', 'chat-viber'),
	},
	{
		value: 'America/North_Dakota/New_Salem',
		label: __('America/North_Dakota/New_Salem', 'chat-viber'),
	},
	{
		value: 'America/Ojinaga',
		label: __('America/Ojinaga', 'chat-viber'),
	},
	{
		value: 'America/Panama',
		label: __('America/Panama', 'chat-viber'),
	},
	{
		value: 'America/Pangnirtung',
		label: __('America/Pangnirtung', 'chat-viber'),
	},
	{
		value: 'America/Paramaribo',
		label: __('America/Paramaribo', 'chat-viber'),
	},
	{
		value: 'America/Phoenix',
		label: __('America/Phoenix', 'chat-viber'),
	},
	{
		value: 'America/Port-au-Prince',
		label: __('America/Port-au-Prince', 'chat-viber'),
	},
	{
		value: 'America/Port_of_Spain',
		label: __('America/Port_of_Spain', 'chat-viber'),
	},
	{
		value: 'America/Porto_Acre',
		label: __('America/Porto_Acre', 'chat-viber'),
	},
	{
		value: 'America/Porto_Velho',
		label: __('America/Porto_Velho', 'chat-viber'),
	},
	{
		value: 'America/Puerto_Rico',
		label: __('America/Puerto_Rico', 'chat-viber'),
	},
	{
		value: 'America/Punta_Arenas',
		label: __('America/Punta_Arenas', 'chat-viber'),
	},
	{
		value: 'America/Rainy_River',
		label: __('America/Rainy_River', 'chat-viber'),
	},
	{
		value: 'America/Rankin_Inlet',
		label: __('America/Rankin_Inlet', 'chat-viber'),
	},
	{
		value: 'America/Recife',
		label: __('America/Recife', 'chat-viber'),
	},
	{
		value: 'America/Regina',
		label: __('America/Regina', 'chat-viber'),
	},
	{
		value: 'America/Resolute',
		label: __('America/Resolute', 'chat-viber'),
	},
	{
		value: 'America/Rio_Branco',
		label: __('America/Rio_Branco', 'chat-viber'),
	},
	{
		value: 'America/Rosario',
		label: __('America/Rosario', 'chat-viber'),
	},
	{
		value: 'America/Santa_Isabel',
		label: __('America/Santa_Isabel', 'chat-viber'),
	},
	{
		value: 'America/Santarem',
		label: __('America/Santarem', 'chat-viber'),
	},
	{
		value: 'America/Santiago',
		label: __('America/Santiago', 'chat-viber'),
	},
	{
		value: 'America/Santo_Domingo',
		label: __('America/Santo_Domingo', 'chat-viber'),
	},
	{
		value: 'America/Sao_Paulo',
		label: __('America/Sao_Paulo', 'chat-viber'),
	},
	{
		value: 'America/Scoresbysund',
		label: __('America/Scoresbysund', 'chat-viber'),
	},
	{
		value: 'America/Shiprock',
		label: __('America/Shiprock', 'chat-viber'),
	},
	{
		value: 'America/Sitka',
		label: __('America/Sitka', 'chat-viber'),
	},
	{
		value: 'America/St_Barthelemy',
		label: __('America/St_Barthelemy', 'chat-viber'),
	},
	{
		value: 'America/St_Johns',
		label: __('America/St_Johns', 'chat-viber'),
	},
	{
		value: 'America/St_Kitts',
		label: __('America/St_Kitts', 'chat-viber'),
	},
	{
		value: 'America/St_Lucia',
		label: __('America/St_Lucia', 'chat-viber'),
	},
	{
		value: 'America/St_Thomas',
		label: __('America/St_Thomas', 'chat-viber'),
	},
	{
		value: 'America/St_Vincent',
		label: __('America/St_Vincent', 'chat-viber'),
	},
	{
		value: 'America/Swift_Current',
		label: __('America/Swift_Current', 'chat-viber'),
	},
	{
		value: 'America/Tegucigalpa',
		label: __('America/Tegucigalpa', 'chat-viber'),
	},
	{
		value: 'America/Thule',
		label: __('America/Thule', 'chat-viber'),
	},
	{
		value: 'America/Thunder_Bay',
		label: __('America/Thunder_Bay', 'chat-viber'),
	},
	{
		value: 'America/Tijuana',
		label: __('America/Tijuana', 'chat-viber'),
	},
	{
		value: 'America/Toronto',
		label: __('America/Toronto', 'chat-viber'),
	},
	{
		value: 'America/Tortola',
		label: __('America/Tortola', 'chat-viber'),
	},
	{
		value: 'America/Vancouver',
		label: __('America/Vancouver', 'chat-viber'),
	},
	{
		value: 'America/Virgin',
		label: __('America/Virgin', 'chat-viber'),
	},
	{
		value: 'America/Whitehorse',
		label: __('America/Whitehorse', 'chat-viber'),
	},
	{
		value: 'America/Winnipeg',
		label: __('America/Winnipeg', 'chat-viber'),
	},
	{
		value: 'America/Yakutat',
		label: __('America/Yakutat', 'chat-viber'),
	},
	{
		value: 'America/Yellowknife',
		label: __('America/Yellowknife', 'chat-viber'),
	},
	{
		value: 'Antarctica/Casey',
		label: __('Antarctica/Casey', 'chat-viber'),
	},
	{
		value: 'Antarctica/Davis',
		label: __('Antarctica/Davis', 'chat-viber'),
	},
	{
		value: 'Antarctica/DumontDUrville',
		label: __('Antarctica/DumontDUrville', 'chat-viber'),
	},
	{
		value: 'Antarctica/Macquarie',
		label: __('Antarctica/Macquarie', 'chat-viber'),
	},
	{
		value: 'Antarctica/Mawson',
		label: __('Antarctica/Mawson', 'chat-viber'),
	},
	{
		value: 'Antarctica/McMurdo',
		label: __('Antarctica/McMurdo', 'chat-viber'),
	},
	{
		value: 'Antarctica/Palmer',
		label: __('Antarctica/Palmer', 'chat-viber'),
	},
	{
		value: 'Antarctica/Rothera',
		label: __('Antarctica/Rothera', 'chat-viber'),
	},
	{
		value: 'Antarctica/South_Pole',
		label: __('Antarctica/South_Pole', 'chat-viber'),
	},
	{
		value: 'Antarctica/Syowa',
		label: __('Antarctica/Syowa', 'chat-viber'),
	},
	{
		value: 'Antarctica/Troll',
		label: __('Antarctica/Troll', 'chat-viber'),
	},
	{
		value: 'Antarctica/Vostok',
		label: __('Antarctica/Vostok', 'chat-viber'),
	},
	{
		value: 'Arctic/Longyearbyen',
		label: __('Arctic/Longyearbyen', 'chat-viber'),
	},
	{
		value: 'Asia/Aden',
		label: __('Asia/Aden', 'chat-viber'),
	},
	{
		value: 'Asia/Almaty',
		label: __('Asia/Almaty', 'chat-viber'),
	},
	{
		value: 'Asia/Amman',
		label: __('Asia/Amman', 'chat-viber'),
	},
	{
		value: 'Asia/Anadyr',
		label: __('Asia/Anadyr', 'chat-viber'),
	},
	{
		value: 'Asia/Aqtau',
		label: __('Asia/Aqtau', 'chat-viber'),
	},
	{
		value: 'Asia/Aqtobe',
		label: __('Asia/Aqtobe', 'chat-viber'),
	},
	{
		value: 'Asia/Ashgabat',
		label: __('Asia/Ashgabat', 'chat-viber'),
	},
	{
		value: 'Asia/Ashkhabad',
		label: __('Asia/Ashkhabad', 'chat-viber'),
	},
	{
		value: 'Asia/Atyrau',
		label: __('Asia/Atyrau', 'chat-viber'),
	},
	{
		value: 'Asia/Baghdad',
		label: __('Asia/Baghdad', 'chat-viber'),
	},
	{
		value: 'Asia/Bahrain',
		label: __('Asia/Bahrain', 'chat-viber'),
	},
	{
		value: 'Asia/Baku',
		label: __('Asia/Baku', 'chat-viber'),
	},
	{
		value: 'Asia/Bangkok',
		label: __('Asia/Bangkok', 'chat-viber'),
	},
	{
		value: 'Asia/Barnaul',
		label: __('Asia/Barnaul', 'chat-viber'),
	},
	{
		value: 'Asia/Beirut',
		label: __('Asia/Beirut', 'chat-viber'),
	},
	{
		value: 'Asia/Bishkek',
		label: __('Asia/Bishkek', 'chat-viber'),
	},
	{
		value: 'Asia/Brunei',
		label: __('Asia/Brunei', 'chat-viber'),
	},
	{
		value: 'Asia/Calcutta',
		label: __('Asia/Calcutta', 'chat-viber'),
	},
	{
		value: 'Asia/Chita',
		label: __('Asia/Chita', 'chat-viber'),
	},
	{
		value: 'Asia/Choibalsan',
		label: __('Asia/Choibalsan', 'chat-viber'),
	},
	{
		value: 'Asia/Chongqing',
		label: __('Asia/Chongqing', 'chat-viber'),
	},
	{
		value: 'Asia/Chungking',
		label: __('Asia/Chungking', 'chat-viber'),
	},
	{
		value: 'Asia/Colombo',
		label: __('Asia/Colombo', 'chat-viber'),
	},
	{
		value: 'Asia/Dacca',
		label: __('Asia/Dacca', 'chat-viber'),
	},
	{
		value: 'Asia/Damascus',
		label: __('Asia/Damascus', 'chat-viber'),
	},
	{
		value: 'Asia/Dhaka',
		label: __('Asia/Dhaka', 'chat-viber'),
	},
	{
		value: 'Asia/Dili',
		label: __('Asia/Dili', 'chat-viber'),
	},
	{
		value: 'Asia/Dubai',
		label: __('Asia/Dubai', 'chat-viber'),
	},
	{
		value: 'Asia/Dushanbe',
		label: __('Asia/Dushanbe', 'chat-viber'),
	},
	{
		value: 'Asia/Famagusta',
		label: __('Asia/Famagusta', 'chat-viber'),
	},
	{
		value: 'Asia/Gaza',
		label: __('Asia/Gaza', 'chat-viber'),
	},
	{
		value: 'Asia/Harbin',
		label: __('Asia/Harbin', 'chat-viber'),
	},
	{
		value: 'Asia/Hebron',
		label: __('Asia/Hebron', 'chat-viber'),
	},
	{
		value: 'Asia/Ho_Chi_Minh',
		label: __('Asia/Ho_Chi_Minh', 'chat-viber'),
	},
	{
		value: 'Asia/Hong_Kong',
		label: __('Asia/Hong_Kong', 'chat-viber'),
	},
	{
		value: 'Asia/Hovd',
		label: __('Asia/Hovd', 'chat-viber'),
	},
	{
		value: 'Asia/Irkutsk',
		label: __('Asia/Irkutsk', 'chat-viber'),
	},
	{
		value: 'Asia/Istanbul',
		label: __('Asia/Istanbul', 'chat-viber'),
	},
	{
		value: 'Asia/Jakarta',
		label: __('Asia/Jakarta', 'chat-viber'),
	},
	{
		value: 'Asia/Jayapura',
		label: __('Asia/Jayapura', 'chat-viber'),
	},
	{
		value: 'Asia/Jerusalem',
		label: __('Asia/Jerusalem', 'chat-viber'),
	},
	{
		value: 'Asia/Kabul',
		label: __('Asia/Kabul', 'chat-viber'),
	},
	{
		value: 'Asia/Kamchatka',
		label: __('Asia/Kamchatka', 'chat-viber'),
	},
	{
		value: 'Asia/Karachi',
		label: __('Asia/Karachi', 'chat-viber'),
	},
	{
		value: 'Asia/Kashgar',
		label: __('Asia/Kashgar', 'chat-viber'),
	},
	{
		value: 'Asia/Kathmandu',
		label: __('Asia/Kathmandu', 'chat-viber'),
	},
	{
		value: 'Asia/Katmandu',
		label: __('Asia/Katmandu', 'chat-viber'),
	},
	{
		value: 'Asia/Khandyga',
		label: __('Asia/Khandyga', 'chat-viber'),
	},
	{
		value: 'Asia/Kolkata',
		label: __('Asia/Kolkata', 'chat-viber'),
	},
	{
		value: 'Asia/Krasnoyarsk',
		label: __('Asia/Krasnoyarsk', 'chat-viber'),
	},
	{
		value: 'Asia/Kuala_Lumpur',
		label: __('Asia/Kuala_Lumpur', 'chat-viber'),
	},
	{
		value: 'Asia/Kuching',
		label: __('Asia/Kuching', 'chat-viber'),
	},
	{
		value: 'Asia/Kuwait',
		label: __('Asia/Kuwait', 'chat-viber'),
	},
	{
		value: 'Asia/Macao',
		label: __('Asia/Macao', 'chat-viber'),
	},
	{
		value: 'Asia/Macau',
		label: __('Asia/Macau', 'chat-viber'),
	},
	{
		value: 'Asia/Magadan',
		label: __('Asia/Magadan', 'chat-viber'),
	},
	{
		value: 'Asia/Makassar',
		label: __('Asia/Makassar', 'chat-viber'),
	},
	{
		value: 'Asia/Manila',
		label: __('Asia/Manila', 'chat-viber'),
	},
	{
		value: 'Asia/Muscat',
		label: __('Asia/Muscat', 'chat-viber'),
	},
	{
		value: 'Asia/Nicosia',
		label: __('Asia/Nicosia', 'chat-viber'),
	},
	{
		value: 'Asia/Novokuznetsk',
		label: __('Asia/Novokuznetsk', 'chat-viber'),
	},
	{
		value: 'Asia/Novosibirsk',
		label: __('Asia/Novosibirsk', 'chat-viber'),
	},
	{
		value: 'Asia/Omsk',
		label: __('Asia/Omsk', 'chat-viber'),
	},
	{
		value: 'Asia/Oral',
		label: __('Asia/Oral', 'chat-viber'),
	},
	{
		value: 'Asia/Phnom_Penh',
		label: __('Asia/Phnom_Penh', 'chat-viber'),
	},
	{
		value: 'Asia/Pontianak',
		label: __('Asia/Pontianak', 'chat-viber'),
	},
	{
		value: 'Asia/Pyongyang',
		label: __('Asia/Pyongyang', 'chat-viber'),
	},
	{
		value: 'Asia/Qatar',
		label: __('Asia/Qatar', 'chat-viber'),
	},
	{
		value: 'Asia/Qyzylorda',
		label: __('Asia/Qyzylorda', 'chat-viber'),
	},
	{
		value: 'Asia/Rangoon',
		label: __('Asia/Rangoon', 'chat-viber'),
	},
	{
		value: 'Asia/Riyadh',
		label: __('Asia/Riyadh', 'chat-viber'),
	},
	{
		value: 'Asia/Saigon',
		label: __('Asia/Saigon', 'chat-viber'),
	},
	{
		value: 'Asia/Sakhalin',
		label: __('Asia/Sakhalin', 'chat-viber'),
	},
	{
		value: 'Asia/Samarkand',
		label: __('Asia/Samarkand', 'chat-viber'),
	},
	{
		value: 'Asia/Seoul',
		label: __('Asia/Seoul', 'chat-viber'),
	},
	{
		value: 'Asia/Shanghai',
		label: __('Asia/Shanghai', 'chat-viber'),
	},
	{
		value: 'Asia/Singapore',
		label: __('Asia/Singapore', 'chat-viber'),
	},
	{
		value: 'Asia/Srednekolymsk',
		label: __('Asia/Srednekolymsk', 'chat-viber'),
	},
	{
		value: 'Asia/Taipei',
		label: __('Asia/Taipei', 'chat-viber'),
	},
	{
		value: 'Asia/Tashkent',
		label: __('Asia/Tashkent', 'chat-viber'),
	},
	{
		value: 'Asia/Tbilisi',
		label: __('Asia/Tbilisi', 'chat-viber'),
	},
	{
		value: 'Asia/Tehran',
		label: __('Asia/Tehran', 'chat-viber'),
	},
	{
		value: 'Asia/Tel_Aviv',
		label: __('Asia/Tel_Aviv', 'chat-viber'),
	},
	{
		value: 'Asia/Thimbu',
		label: __('Asia/Thimbu', 'chat-viber'),
	},
	{
		value: 'Asia/Thimphu',
		label: __('Asia/Thimphu', 'chat-viber'),
	},
	{
		value: 'Asia/Tokyo',
		label: __('Asia/Tokyo', 'chat-viber'),
	},
	{
		value: 'Asia/Tomsk',
		label: __('Asia/Tomsk', 'chat-viber'),
	},
	{
		value: 'Asia/Ujung_Pandang',
		label: __('Asia/Ujung_Pandang', 'chat-viber'),
	},
	{
		value: 'Asia/Ulaanbaatar',
		label: __('Asia/Ulaanbaatar', 'chat-viber'),
	},
	{
		value: 'Asia/Ulan_Bator',
		label: __('Asia/Ulan_Bator', 'chat-viber'),
	},
	{
		value: 'Asia/Urumqi',
		label: __('Asia/Urumqi', 'chat-viber'),
	},
	{
		value: 'Asia/Ust-Nera',
		label: __('Asia/Ust-Nera', 'chat-viber'),
	},
	{
		value: 'Asia/Vientiane',
		label: __('Asia/Vientiane', 'chat-viber'),
	},
	{
		value: 'Asia/Vladivostok',
		label: __('Asia/Vladivostok', 'chat-viber'),
	},
	{
		value: 'Asia/Yakutsk',
		label: __('Asia/Yakutsk', 'chat-viber'),
	},
	{
		value: 'Asia/Yangon',
		label: __('Asia/Yangon', 'chat-viber'),
	},
	{
		value: 'Asia/Yekaterinburg',
		label: __('Asia/Yekaterinburg', 'chat-viber'),
	},
	{
		value: 'Asia/Yerevan',
		label: __('Asia/Yerevan', 'chat-viber'),
	},
	{
		value: 'Atlantic/Azores',
		label: __('Atlantic/Azores', 'chat-viber'),
	},
	{
		value: 'Atlantic/Bermuda',
		label: __('Atlantic/Bermuda', 'chat-viber'),
	},
	{
		value: 'Atlantic/Canary',
		label: __('Atlantic/Canary', 'chat-viber'),
	},
	{
		value: 'Atlantic/Cape_Verde',
		label: __('Atlantic/Cape_Verde', 'chat-viber'),
	},
	{
		value: 'Atlantic/Faeroe',
		label: __('Atlantic/Faeroe', 'chat-viber'),
	},
	{
		value: 'Atlantic/Faroe',
		label: __('Atlantic/Faroe', 'chat-viber'),
	},
	{
		value: 'Atlantic/Jan_Mayen',
		label: __('Atlantic/Jan_Mayen', 'chat-viber'),
	},
	{
		value: 'Atlantic/Madeira',
		label: __('Atlantic/Madeira', 'chat-viber'),
	},
	{
		value: 'Atlantic/Reykjavik',
		label: __('Atlantic/Reykjavik', 'chat-viber'),
	},
	{
		value: 'Atlantic/South_Georgia',
		label: __('Atlantic/South_Georgia', 'chat-viber'),
	},
	{
		value: 'Atlantic/St_Helena',
		label: __('Atlantic/St_Helena', 'chat-viber'),
	},
	{
		value: 'Atlantic/Stanley',
		label: __('Atlantic/Stanley', 'chat-viber'),
	},
	{
		value: 'Australia/ACT',
		label: __('Australia/ACT', 'chat-viber'),
	},
	{
		value: 'Australia/Adelaide',
		label: __('Australia/Adelaide', 'chat-viber'),
	},
	{
		value: 'Australia/Brisbane',
		label: __('Australia/Brisbane', 'chat-viber'),
	},
	{
		value: 'Australia/Broken_Hill',
		label: __('Australia/Broken_Hill', 'chat-viber'),
	},
	{
		value: 'Australia/Canberra',
		label: __('Australia/Canberra', 'chat-viber'),
	},
	{
		value: 'Australia/Currie',
		label: __('Australia/Currie', 'chat-viber'),
	},
	{
		value: 'Australia/Darwin',
		label: __('Australia/Darwin', 'chat-viber'),
	},
	{
		value: 'Australia/Eucla',
		label: __('Australia/Eucla', 'chat-viber'),
	},
	{
		value: 'Australia/Hobart',
		label: __('Australia/Hobart', 'chat-viber'),
	},
	{
		value: 'Australia/LHI',
		label: __('Australia/LHI', 'chat-viber'),
	},
	{
		value: 'Australia/Lindeman',
		label: __('Australia/Lindeman', 'chat-viber'),
	},
	{
		value: 'Australia/Lord_Howe',
		label: __('Australia/Lord_Howe', 'chat-viber'),
	},
	{
		value: 'Australia/Melbourne',
		label: __('Australia/Melbourne', 'chat-viber'),
	},
	{
		value: 'Australia/NSW',
		label: __('Australia/NSW', 'chat-viber'),
	},
	{
		value: 'Australia/North',
		label: __('Australia/North', 'chat-viber'),
	},
	{
		value: 'Australia/Perth',
		label: __('Australia/Perth', 'chat-viber'),
	},
	{
		value: 'Australia/Queensland',
		label: __('Australia/Queensland', 'chat-viber'),
	},
	{
		value: 'Australia/South',
		label: __('Australia/South', 'chat-viber'),
	},
	{
		value: 'Australia/Sydney',
		label: __('Australia/Sydney', 'chat-viber'),
	},
	{
		value: 'Australia/Tasmania',
		label: __('Australia/Tasmania', 'chat-viber'),
	},
	{
		value: 'Australia/Victoria',
		label: __('Australia/Victoria', 'chat-viber'),
	},
	{
		value: 'Australia/West',
		label: __('Australia/West', 'chat-viber'),
	},
	{
		value: 'Australia/Yancowinna',
		label: __('Australia/Yancowinna', 'chat-viber'),
	},
	{
		value: 'Brazil/Acre',
		label: __('Brazil/Acre', 'chat-viber'),
	},
	{
		value: 'Brazil/DeNoronha',
		label: __('Brazil/DeNoronha', 'chat-viber'),
	},
	{
		value: 'Brazil/East',
		label: __('Brazil/East', 'chat-viber'),
	},
	{
		value: 'Brazil/West',
		label: __('Brazil/West', 'chat-viber'),
	},
	{
		value: 'CET',
		label: __('CET', 'chat-viber'),
	},
	{
		value: 'CST6CDT',
		label: __('CST6CDT', 'chat-viber'),
	},
	{
		value: 'Canada/Atlantic',
		label: __('Canada/Atlantic', 'chat-viber'),
	},
	{
		value: 'Canada/Central',
		label: __('Canada/Central', 'chat-viber'),
	},
	{
		value: 'Canada/Eastern',
		label: __('Canada/Eastern', 'chat-viber'),
	},
	{
		value: 'Canada/Mountain',
		label: __('Canada/Mountain', 'chat-viber'),
	},
	{
		value: 'Canada/Newfoundland',
		label: __('Canada/Newfoundland', 'chat-viber'),
	},
	{
		value: 'Canada/Pacific',
		label: __('Canada/Pacific', 'chat-viber'),
	},
	{
		value: 'Canada/Saskatchewan',
		label: __('Canada/Saskatchewan', 'chat-viber'),
	},
	{
		value: 'Canada/Yukon',
		label: __('Canada/Yukon', 'chat-viber'),
	},
	{
		value: 'Chile/Continental',
		label: __('Chile/Continental', 'chat-viber'),
	},
	{
		value: 'Chile/EasterIsland',
		label: __('Chile/EasterIsland', 'chat-viber'),
	},
	{
		value: 'Cuba',
		label: __('Cuba', 'chat-viber'),
	},
	{
		value: 'EET',
		label: __('EET', 'chat-viber'),
	},
	{
		value: 'EST',
		label: __('EST', 'chat-viber'),
	},
	{
		value: 'EST5EDT',
		label: __('EST5EDT', 'chat-viber'),
	},
	{
		value: 'Egypt',
		label: __('Egypt', 'chat-viber'),
	},
	{
		value: 'Eire',
		label: __('Eire', 'chat-viber'),
	},
	{
		value: 'Etc/GMT',
		label: __('Etc/GMT', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+0',
		label: __('Etc/GMT+0', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+1',
		label: __('Etc/GMT+1', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+10',
		label: __('Etc/GMT+10', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+11',
		label: __('Etc/GMT+11', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+12',
		label: __('Etc/GMT+12', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+2',
		label: __('Etc/GMT+2', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+3',
		label: __('Etc/GMT+3', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+4',
		label: __('Etc/GMT+4', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+5',
		label: __('Etc/GMT+5', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+6',
		label: __('Etc/GMT+6', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+7',
		label: __('Etc/GMT+7', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+8',
		label: __('Etc/GMT+8', 'chat-viber'),
	},
	{
		value: 'Etc/GMT+9',
		label: __('Etc/GMT+9', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-0',
		label: __('Etc/GMT-0', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-1',
		label: __('Etc/GMT-1', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-10',
		label: __('Etc/GMT-10', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-11',
		label: __('Etc/GMT-11', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-12',
		label: __('Etc/GMT-12', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-13',
		label: __('Etc/GMT-13', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-14',
		label: __('Etc/GMT-14', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-2',
		label: __('Etc/GMT-2', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-3',
		label: __('Etc/GMT-3', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-4',
		label: __('Etc/GMT-4', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-5',
		label: __('Etc/GMT-5', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-6',
		label: __('Etc/GMT-6', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-7',
		label: __('Etc/GMT-7', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-8',
		label: __('Etc/GMT-8', 'chat-viber'),
	},
	{
		value: 'Etc/GMT-9',
		label: __('Etc/GMT-9', 'chat-viber'),
	},
	{
		value: 'Etc/GMT0',
		label: __('Etc/GMT0', 'chat-viber'),
	},
	{
		value: 'Etc/Greenwich',
		label: __('Etc/Greenwich', 'chat-viber'),
	},
	{
		value: 'Etc/UCT',
		label: __('Etc/UCT', 'chat-viber'),
	},
	{
		value: 'Etc/UTC',
		label: __('Etc/UTC', 'chat-viber'),
	},
	{
		value: 'Etc/Universal',
		label: __('Etc/Universal', 'chat-viber'),
	},
	{
		value: 'Etc/Zulu',
		label: __('Etc/Zulu', 'chat-viber'),
	},
	{
		value: 'Europe/Amsterdam',
		label: __('Europe/Amsterdam', 'chat-viber'),
	},
	{
		value: 'Europe/Andorra',
		label: __('Europe/Andorra', 'chat-viber'),
	},
	{
		value: 'Europe/Astrakhan',
		label: __('Europe/Astrakhan', 'chat-viber'),
	},
	{
		value: 'Europe/Athens',
		label: __('Europe/Athens', 'chat-viber'),
	},
	{
		value: 'Europe/Belfast',
		label: __('Europe/Belfast', 'chat-viber'),
	},
	{
		value: 'Europe/Belgrade',
		label: __('Europe/Belgrade', 'chat-viber'),
	},
	{
		value: 'Europe/Berlin',
		label: __('Europe/Berlin', 'chat-viber'),
	},
	{
		value: 'Europe/Bratislava',
		label: __('Europe/Bratislava', 'chat-viber'),
	},
	{
		value: 'Europe/Brussels',
		label: __('Europe/Brussels', 'chat-viber'),
	},
	{
		value: 'Europe/Bucharest',
		label: __('Europe/Bucharest', 'chat-viber'),
	},
	{
		value: 'Europe/Budapest',
		label: __('Europe/Budapest', 'chat-viber'),
	},
	{
		value: 'Europe/Busingen',
		label: __('Europe/Busingen', 'chat-viber'),
	},
	{
		value: 'Europe/Chisinau',
		label: __('Europe/Chisinau', 'chat-viber'),
	},
	{
		value: 'Europe/Copenhagen',
		label: __('Europe/Copenhagen', 'chat-viber'),
	},
	{
		value: 'Europe/Dublin',
		label: __('Europe/Dublin', 'chat-viber'),
	},
	{
		value: 'Europe/Gibraltar',
		label: __('Europe/Gibraltar', 'chat-viber'),
	},
	{
		value: 'Europe/Guernsey',
		label: __('Europe/Guernsey', 'chat-viber'),
	},
	{
		value: 'Europe/Helsinki',
		label: __('Europe/Helsinki', 'chat-viber'),
	},
	{
		value: 'Europe/Isle_of_Man',
		label: __('Europe/Isle_of_Man', 'chat-viber'),
	},
	{
		value: 'Europe/Istanbul',
		label: __('Europe/Istanbul', 'chat-viber'),
	},
	{
		value: 'Europe/Jersey',
		label: __('Europe/Jersey', 'chat-viber'),
	},
	{
		value: 'Europe/Kaliningrad',
		label: __('Europe/Kaliningrad', 'chat-viber'),
	},
	{
		value: 'Europe/Kiev',
		label: __('Europe/Kiev', 'chat-viber'),
	},
	{
		value: 'Europe/Kirov',
		label: __('Europe/Kirov', 'chat-viber'),
	},
	{
		value: 'Europe/Lisbon',
		label: __('Europe/Lisbon', 'chat-viber'),
	},
	{
		value: 'Europe/Ljubljana',
		label: __('Europe/Ljubljana', 'chat-viber'),
	},
	{
		value: 'Europe/London',
		label: __('Europe/London', 'chat-viber'),
	},
	{
		value: 'Europe/Luxembourg',
		label: __('Europe/Luxembourg', 'chat-viber'),
	},
	{
		value: 'Europe/Madrid',
		label: __('Europe/Madrid', 'chat-viber'),
	},
	{
		value: 'Europe/Malta',
		label: __('Europe/Malta', 'chat-viber'),
	},
	{
		value: 'Europe/Mariehamn',
		label: __('Europe/Mariehamn', 'chat-viber'),
	},
	{
		value: 'Europe/Minsk',
		label: __('Europe/Minsk', 'chat-viber'),
	},
	{
		value: 'Europe/Monaco',
		label: __('Europe/Monaco', 'chat-viber'),
	},
	{
		value: 'Europe/Moscow',
		label: __('Europe/Moscow', 'chat-viber'),
	},
	{
		value: 'Europe/Nicosia',
		label: __('Europe/Nicosia', 'chat-viber'),
	},
	{
		value: 'Europe/Oslo',
		label: __('Europe/Oslo', 'chat-viber'),
	},
	{
		value: 'Europe/Paris',
		label: __('Europe/Paris', 'chat-viber'),
	},
	{
		value: 'Europe/Podgorica',
		label: __('Europe/Podgorica', 'chat-viber'),
	},
	{
		value: 'Europe/Prague',
		label: __('Europe/Prague', 'chat-viber'),
	},
	{
		value: 'Europe/Riga',
		label: __('Europe/Riga', 'chat-viber'),
	},
	{
		value: 'Europe/Rome',
		label: __('Europe/Rome', 'chat-viber'),
	},
	{
		value: 'Europe/Samara',
		label: __('Europe/Samara', 'chat-viber'),
	},
	{
		value: 'Europe/San_Marino',
		label: __('Europe/San_Marino', 'chat-viber'),
	},
	{
		value: 'Europe/Sarajevo',
		label: __('Europe/Sarajevo', 'chat-viber'),
	},
	{
		value: 'Europe/Saratov',
		label: __('Europe/Saratov', 'chat-viber'),
	},
	{
		value: 'Europe/Simferopol',
		label: __('Europe/Simferopol', 'chat-viber'),
	},
	{
		value: 'Europe/Skopje',
		label: __('Europe/Skopje', 'chat-viber'),
	},
	{
		value: 'Europe/Sofia',
		label: __('Europe/Sofia', 'chat-viber'),
	},
	{
		value: 'Europe/Stockholm',
		label: __('Europe/Stockholm', 'chat-viber'),
	},
	{
		value: 'Europe/Tallinn',
		label: __('Europe/Tallinn', 'chat-viber'),
	},
	{
		value: 'Europe/Tirane',
		label: __('Europe/Tirane', 'chat-viber'),
	},
	{
		value: 'Europe/Tiraspol',
		label: __('Europe/Tiraspol', 'chat-viber'),
	},
	{
		value: 'Europe/Ulyanovsk',
		label: __('Europe/Ulyanovsk', 'chat-viber'),
	},
	{
		value: 'Europe/Uzhgorod',
		label: __('Europe/Uzhgorod', 'chat-viber'),
	},
	{
		value: 'Europe/Vaduz',
		label: __('Europe/Vaduz', 'chat-viber'),
	},
	{
		value: 'Europe/Vatican',
		label: __('Europe/Vatican', 'chat-viber'),
	},
	{
		value: 'Europe/Vienna',
		label: __('Europe/Vienna', 'chat-viber'),
	},
	{
		value: 'Europe/Vilnius',
		label: __('Europe/Vilnius', 'chat-viber'),
	},
	{
		value: 'Europe/Volgograd',
		label: __('Europe/Volgograd', 'chat-viber'),
	},
	{
		value: 'Europe/Warsaw',
		label: __('Europe/Warsaw', 'chat-viber'),
	},
	{
		value: 'Europe/Zagreb',
		label: __('Europe/Zagreb', 'chat-viber'),
	},
	{
		value: 'Europe/Zaporozhye',
		label: __('Europe/Zaporozhye', 'chat-viber'),
	},
	{
		value: 'Europe/Zurich',
		label: __('Europe/Zurich', 'chat-viber'),
	},
	{
		value: 'GB',
		label: __('GB', 'chat-viber'),
	},
	{
		value: 'GB-Eire',
		label: __('GB-Eire', 'chat-viber'),
	},
	{
		value: 'GMT',
		label: __('GMT', 'chat-viber'),
	},
	{
		value: 'GMT+0',
		label: __('GMT+0', 'chat-viber'),
	},
	{
		value: 'GMT-0',
		label: __('GMT-0', 'chat-viber'),
	},
	{
		value: 'GMT0',
		label: __('GMT0', 'chat-viber'),
	},
	{
		value: 'Greenwich',
		label: __('Greenwich', 'chat-viber'),
	},
	{
		value: 'HST',
		label: __('HST', 'chat-viber'),
	},
	{
		value: 'Hongkong',
		label: __('Hongkong', 'chat-viber'),
	},
	{
		value: 'Iceland',
		label: __('Iceland', 'chat-viber'),
	},
	{
		value: 'Indian/Antananarivo',
		label: __('Indian/Antananarivo', 'chat-viber'),
	},
	{
		value: 'Indian/Chagos',
		label: __('Indian/Chagos', 'chat-viber'),
	},
	{
		value: 'Indian/Christmas',
		label: __('Indian/Christmas', 'chat-viber'),
	},
	{
		value: 'Indian/Cocos',
		label: __('Indian/Cocos', 'chat-viber'),
	},
	{
		value: 'Indian/Comoro',
		label: __('Indian/Comoro', 'chat-viber'),
	},
	{
		value: 'Indian/Kerguelen',
		label: __('Indian/Kerguelen', 'chat-viber'),
	},
	{
		value: 'Indian/Mahe',
		label: __('Indian/Mahe', 'chat-viber'),
	},
	{
		value: 'Indian/Maldives',
		label: __('Indian/Maldives', 'chat-viber'),
	},
	{
		value: 'Indian/Mauritius',
		label: __('Indian/Mauritius', 'chat-viber'),
	},
	{
		value: 'Indian/Mayotte',
		label: __('Indian/Mayotte', 'chat-viber'),
	},
	{
		value: 'Indian/Reunion',
		label: __('Indian/Reunion', 'chat-viber'),
	},
	{
		value: 'Iran',
		label: __('Iran', 'chat-viber'),
	},
	{
		value: 'Israel',
		label: __('Israel', 'chat-viber'),
	},
	{
		value: 'Jamaica',
		label: __('Jamaica', 'chat-viber'),
	},
	{
		value: 'Japan',
		label: __('Japan', 'chat-viber'),
	},
	{
		value: 'Kwajalein',
		label: __('Kwajalein', 'chat-viber'),
	},
	{
		value: 'Libya',
		label: __('Libya', 'chat-viber'),
	},
	{
		value: 'MET',
		label: __('MET', 'chat-viber'),
	},
	{
		value: 'MST',
		label: __('MST', 'chat-viber'),
	},
	{
		value: 'MST7MDT',
		label: __('MST7MDT', 'chat-viber'),
	},
	{
		value: 'Mexico/BajaNorte',
		label: __('Mexico/BajaNorte', 'chat-viber'),
	},
	{
		value: 'Mexico/BajaSur',
		label: __('Mexico/BajaSur', 'chat-viber'),
	},
	{
		value: 'Mexico/General',
		label: __('Mexico/General', 'chat-viber'),
	},
	{
		value: 'NZ',
		label: __('NZ', 'chat-viber'),
	},
	{
		value: 'NZ-CHAT',
		label: __('NZ-CHAT', 'chat-viber'),
	},
	{
		value: 'Navajo',
		label: __('Navajo', 'chat-viber'),
	},
	{
		value: 'PRC',
		label: __('PRC', 'chat-viber'),
	},
	{
		value: 'PST8PDT',
		label: __('PST8PDT', 'chat-viber'),
	},
	{
		value: 'Pacific/Apia',
		label: __('Pacific/Apia', 'chat-viber'),
	},
	{
		value: 'Pacific/Auckland',
		label: __('Pacific/Auckland', 'chat-viber'),
	},
	{
		value: 'Pacific/Bougainville',
		label: __('Pacific/Bougainville', 'chat-viber'),
	},
	{
		value: 'Pacific/Chatham',
		label: __('Pacific/Chatham', 'chat-viber'),
	},
	{
		value: 'Pacific/Chuuk',
		label: __('Pacific/Chuuk', 'chat-viber'),
	},
	{
		value: 'Pacific/Easter',
		label: __('Pacific/Easter', 'chat-viber'),
	},
	{
		value: 'Pacific/Efate',
		label: __('Pacific/Efate', 'chat-viber'),
	},
	{
		value: 'Pacific/Enderbury',
		label: __('Pacific/Enderbury', 'chat-viber'),
	},
	{
		value: 'Pacific/Fakaofo',
		label: __('Pacific/Fakaofo', 'chat-viber'),
	},
	{
		value: 'Pacific/Fiji',
		label: __('Pacific/Fiji', 'chat-viber'),
	},
	{
		value: 'Pacific/Funafuti',
		label: __('Pacific/Funafuti', 'chat-viber'),
	},
	{
		value: 'Pacific/Galapagos',
		label: __('Pacific/Galapagos', 'chat-viber'),
	},
	{
		value: 'Pacific/Gambier',
		label: __('Pacific/Gambier', 'chat-viber'),
	},
	{
		value: 'Pacific/Guadalcanal',
		label: __('Pacific/Guadalcanal', 'chat-viber'),
	},
	{
		value: 'Pacific/Guam',
		label: __('Pacific/Guam', 'chat-viber'),
	},
	{
		value: 'Pacific/Honolulu',
		label: __('Pacific/Honolulu', 'chat-viber'),
	},
	{
		value: 'Pacific/Johnston',
		label: __('Pacific/Johnston', 'chat-viber'),
	},
	{
		value: 'Pacific/Kiritimati',
		label: __('Pacific/Kiritimati', 'chat-viber'),
	},
	{
		value: 'Pacific/Kosrae',
		label: __('Pacific/Kosrae', 'chat-viber'),
	},
	{
		value: 'Pacific/Kwajalein',
		label: __('Pacific/Kwajalein', 'chat-viber'),
	},
	{
		value: 'Pacific/Majuro',
		label: __('Pacific/Majuro', 'chat-viber'),
	},
	{
		value: 'Pacific/Marquesas',
		label: __('Pacific/Marquesas', 'chat-viber'),
	},
	{
		value: 'Pacific/Midway',
		label: __('Pacific/Midway', 'chat-viber'),
	},
	{
		value: 'Pacific/Nauru',
		label: __('Pacific/Nauru', 'chat-viber'),
	},
	{
		value: 'Pacific/Niue',
		label: __('Pacific/Niue', 'chat-viber'),
	},
	{
		value: 'Pacific/Norfolk',
		label: __('Pacific/Norfolk', 'chat-viber'),
	},
	{
		value: 'Pacific/Noumea',
		label: __('Pacific/Noumea', 'chat-viber'),
	},
	{
		value: 'Pacific/Pago_Pago',
		label: __('Pacific/Pago_Pago', 'chat-viber'),
	},
	{
		value: 'Pacific/Palau',
		label: __('Pacific/Palau', 'chat-viber'),
	},
	{
		value: 'Pacific/Pitcairn',
		label: __('Pacific/Pitcairn', 'chat-viber'),
	},
	{
		value: 'Pacific/Pohnpei',
		label: __('Pacific/Pohnpei', 'chat-viber'),
	},
	{
		value: 'Pacific/Ponape',
		label: __('Pacific/Ponape', 'chat-viber'),
	},
	{
		value: 'Pacific/Port_Moresby',
		label: __('Pacific/Port_Moresby', 'chat-viber'),
	},
	{
		value: 'Pacific/Rarotonga',
		label: __('Pacific/Rarotonga', 'chat-viber'),
	},
	{
		value: 'Pacific/Saipan',
		label: __('Pacific/Saipan', 'chat-viber'),
	},
	{
		value: 'Pacific/Samoa',
		label: __('Pacific/Samoa', 'chat-viber'),
	},
	{
		value: 'Pacific/Tahiti',
		label: __('Pacific/Tahiti', 'chat-viber'),
	},
	{
		value: 'Pacific/Tarawa',
		label: __('Pacific/Tarawa', 'chat-viber'),
	},
	{
		value: 'Pacific/Tongatapu',
		label: __('Pacific/Tongatapu', 'chat-viber'),
	},
	{
		value: 'Pacific/Truk',
		label: __('Pacific/Truk', 'chat-viber'),
	},
	{
		value: 'Pacific/Wake',
		label: __('Pacific/Wake', 'chat-viber'),
	},
	{
		value: 'Pacific/Wallis',
		label: __('Pacific/Wallis', 'chat-viber'),
	},
	{
		value: 'Pacific/Yap',
		label: __('Pacific/Yap', 'chat-viber'),
	},
	{
		value: 'Poland',
		label: __('Poland', 'chat-viber'),
	},
	{
		value: 'Portugal',
		label: __('Portugal', 'chat-viber'),
	},
	{
		value: 'ROC',
		label: __('ROC', 'chat-viber'),
	},
	{
		value: 'ROK',
		label: __('ROK', 'chat-viber'),
	},
	{
		value: 'Singapore',
		label: __('Singapore', 'chat-viber'),
	},
	{
		value: 'Turkey',
		label: __('Turkey', 'chat-viber'),
	},
	{
		value: 'UCT',
		label: __('UCT', 'chat-viber'),
	},
	{
		value: 'US/Alaska',
		label: __('US/Alaska', 'chat-viber'),
	},
	{
		value: 'US/Aleutian',
		label: __('US/Aleutian', 'chat-viber'),
	},
	{
		value: 'US/Arizona',
		label: __('US/Arizona', 'chat-viber'),
	},
	{
		value: 'US/Central',
		label: __('US/Central', 'chat-viber'),
	},
	{
		value: 'US/East-Indiana',
		label: __('US/East-Indiana', 'chat-viber'),
	},
	{
		value: 'US/Eastern',
		label: __('US/Eastern', 'chat-viber'),
	},
	{
		value: 'US/Hawaii',
		label: __('US/Hawaii', 'chat-viber'),
	},
	{
		value: 'US/Indiana-Starke',
		label: __('US/Indiana-Starke', 'chat-viber'),
	},
	{
		value: 'US/Michigan',
		label: __('US/Michigan', 'chat-viber'),
	},
	{
		value: 'US/Mountain',
		label: __('US/Mountain', 'chat-viber'),
	},
	{
		value: 'US/Pacific',
		label: __('US/Pacific', 'chat-viber'),
	},
	{
		value: 'US/Pacific-New',
		label: __('US/Pacific-New', 'chat-viber'),
	},
	{
		value: 'US/Samoa',
		label: __('US/Samoa', 'chat-viber'),
	},
	{
		value: 'UTC',
		label: __('UTC', 'chat-viber'),
	},
	{
		value: 'Universal',
		label: __('Universal', 'chat-viber'),
	},
	{
		value: 'W-SU',
		label: __('W-SU', 'chat-viber'),
	},
	{
		value: 'WET',
		label: __('WET', 'chat-viber'),
	},
	{
		value: 'Zulu',
		label: __('Zulu', 'chat-viber'),
	},
];

export default function Edit(props) {
	const { attributes, setAttributes } = props;

	const {
		buttonSize,
		buttonType,
		borderRadius,
		text,
		info,
		title,
		online,
		offline,
		textAlignment,
		iconTarget,
		visibility,
		numberInput,
		imageUrl,
		timeZone,
		mondayStartTime,
		mondayEndTime,
		tuesdayStartTime,
		tuesdayEndTime,
		wednesdayStartTime,
		wednesdayEndTime,
		thursdayStartTime,
		thursdayEndTime,
		fridayStartTime,
		fridayEndTime,
		saturdayStartTime,
		saturdayEndTime,
		sundayStartTime,
		sundayEndTime,
	} = attributes;

	// Timezone select and filter //
	const [filteredOptions, setFilteredOptions] = useState(timezones);
	function onInputChange(value) {
		setFilteredOptions(
			timezones.filter((timezone) =>
				timezone.label.toLowerCase().includes(value.toLowerCase())
			)
		);
	}
	function onFontSizeChange(value) {
		setAttributes({ timeZone: value });
	}

	// Image upload  //
	const onSelectImage = (image) => {
		setAttributes({
			imageUrl: image.url,
		});
	};

	const onChangeAlignment = (newAlignment) => {
		setAttributes({ textAlignment: newAlignment });
	};
	const onChangeText = (newText) => {
		setAttributes({ text: newText });
	};
	const advancedBtnInfo = (newInfo) => {
		setAttributes({ info: newInfo });
	};
	const advancedBtnTitle = (newTitle) => {
		setAttributes({ title: newTitle });
	};
	const advancedBtnOnlineBadge = (newOnline) => {
		setAttributes({ online: newOnline });
	};
	const advancedBtnOfflineBadge = (newOnline) => {
		setAttributes({ offline: newOnline });
	};
	const onIconTarget = (iconTargets) => {
		setAttributes({ iconTarget: iconTargets });
	};
	
	

	const textClasses = classnames(`text-box-align-${textAlignment}`);

	const classes = classnames(`vChat-button-4 vc-btn-bg`);

	const buttonSizeOptions = [
		{ value: 'size-small', label: __('Small', 'chat-viber') },
		{ value: 'size-medium', label: __('Medium', 'chat-viber') },
		{ value: 'size-large', label: __('Large', 'chat-viber') },
	];
	const buttonTypeOptions = [
		{ value: 'basic-button', label: __('Basic Button', 'chat-viber') },
		{ value: 'advance-button', label: __('Advance Button', 'chat-viber') },
	];
	const borderRadiusOptions = [
		{ value: 'border-squared', label: __('Border Squared', 'chat-viber') },
		{ value: 'border-rounded', label: __('Border Rounded', 'chat-viber') }
	];
	const visibilityOn = [
		{ value: '', label: __('Everywhere', 'chat-viber') },
		{ value: 'vc-desktop-only', label: __('Desktop only', 'chat-viber') },
		{ value: 'vc-tablet-only', label: __('Tablets only', 'chat-viber') },
		{
			value: 'vc-mobile-tablet-only',
			label: __('Mobile and tablets', 'chat-viber'),
		},
		{ value: 'vc-mobile-only', label: __('Mobile only', 'chat-viber') },
	];
	return (
		<>
			<InspectorControls>
				<PanelBody>
					<SelectControl
						label={__('Button Type', 'chat-viber')}
						value={buttonType}
						options={buttonTypeOptions.map(({ value, label }) => ({
							value,
							label,
						}))}
						onChange={(newButton) => {
							setAttributes({ buttonType: newButton });
						}}
						help={__('Choose the type of button', 'chat-viber')}
					/>
				</PanelBody>
			</InspectorControls>
			{buttonType === 'basic-button' ? (
				<>
					<InspectorControls>
						<PanelBody
							title={__('Ganerel settings', 'chat-viber')}
							initialOpen={false}
						>
							<TextControl
								label={__('Number', 'chat-viber')}
								value={numberInput}
								onChange={(value) =>
									setAttributes({ numberInput: value })
								}
								help={__('Add your viber number including country code. eg: +8801235445452', 'chat-viber')}
							/>
							
							<TextControl
								label={__('Button label', 'chat-viber')}
								value={text}
								onChange={(value) =>
									setAttributes({ text: value })
								}
								help={__('Add Custom Button Label', 'chat-viber')}
							/>
						</PanelBody>
						<PanelBody
							title={__('Appearance settings', 'chat-viber')}
							initialOpen={false}
						>
							<SelectControl
								label={__('Visibility on', 'chat-viber')}
								value={visibility}
								options={visibilityOn.map(
									({ value, label }) => ({
										value,
										label,
									})
								)}
								onChange={(newSize) => {
									setAttributes({ visibility: newSize });
								}}
							/>
							<SelectControl
								label={__('Size', 'chat-viber')}
								value={buttonSize}
								options={buttonSizeOptions.map(
									({ value, label }) => ({
										value,
										label,
									})
								)}
								onChange={(newSize) => {
									setAttributes({ buttonSize: newSize });
								}}
							/>
							<ToggleControl
								label={__('Add Icon', 'chat-viber')}
								checked={iconTarget}
								onChange={onIconTarget}
							/>
							<SelectControl
								label={__('Border Radius', 'chat-viber')}
								value={borderRadius}
								options={borderRadiusOptions.map(
									({ value, label }) => ({
										value,
										label,
									})
								)}
								onChange={(newSize) => {
									setAttributes({ borderRadius: newSize });
								}}
							/>
							<AlignmentToolbar
							label={__('Allignment', 'chat-viber')}
							value={textAlignment}
							onChange={onChangeAlignment}
						/>
						</PanelBody>
					</InspectorControls>
					<BlockControls>
						<AlignmentToolbar
							value={textAlignment}
							onChange={onChangeAlignment}
						/>
					</BlockControls>

					<div className={`button-wrapper vchat-editor ${textClasses}`}>
						<a
							{...useBlockProps({
								className: `${classes} ${buttonSize} ${borderRadius} ${visibility}`,
							})}
						>
							{iconTarget && (
								<span className="dashicons dashicons-share-alt"></span>
							)}
							<RichText
								onChange={onChangeText}
								value={text}
								placeholder={__(
									'How can I help you?',
									'chat-viber'
								)}
								tagName="span"
								allowedFormats={[]}
							/>
						</a>
					</div>
				</>
			) : (
				<>
					<InspectorControls>
						<PanelBody
							title={__('Ganeral Setting', 'chat-viber')}
							initialOpen={false}
						>
							<TextControl
								label={__('Number', 'chat-viber')}
								value={numberInput}
								onChange={(value) =>
									setAttributes({ numberInput: value })
								}
								help={__('Add your viber number including country code. eg: +8801235445452', 'chat-viber')}
							/>
							<MediaUpload
								label={__('Agent photo', 'chat-viber')}
								onSelect={onSelectImage}
								allowedTypes={['image']}
								render={({ open }) => (
									<Button
										onClick={open}
										style={{
											marginBottom: '20px',
											fontSize: '16px',
										}}
									>
										<span className="dashicons dashicons-cloud-upload"></span>{' '}
										Upload Image
									</Button>
								)}
							/>
							<TextControl
								label={__('Agent Info', 'chat-viber')}
								value={info}
								help={__('Add agent name and designation to show in button', 'chat-viber')}
								onChange={(value) =>
									setAttributes({ info: value })
								}
							/>
							<TextControl
								label={__('Button label', 'chat-viber')}
								value={title}
								onChange={(value) =>
									setAttributes({ title: value })
								}
								help={__('Add Custom Button Label', 'chat-viber')}
							/>
							<TextControl
								label={__('Online badge text', 'chat-viber')}
								value={online}
								help={__('Add Custom badge text when user in online', 'chat-viber')}
								onChange={(value) =>
									setAttributes({ online: value })
								}
							/>
							<TextControl
								label={__('Offline badge text', 'chat-viber')}
								value={offline}
								help={__('Add Custom badge text when user in offline', 'chat-viber')}
								onChange={(value) =>
									setAttributes({ offline: value })
								}
							/>
						</PanelBody>
						<PanelBody
							title={__('Chat Settings', 'chat-viber')}
							initialOpen={false}
						>
							<ComboboxControl
								label={__('Timezone', 'chat-viber')}
								value={timeZone}
								options={filteredOptions}
								onChange={onFontSizeChange}
								onInputChange={onInputChange}
								help={__('When using the date and time from the user browser you can transform it to your current timezone (in case your user is in a different timezone)', 'chat-viber')}
							/>
							<PanelBody
								title={__('Monday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={mondayStartTime}
									onChange={(value) =>
										setAttributes({
											mondayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={mondayEndTime}
									onChange={(value) =>
										setAttributes({ mondayEndTime: value })
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
							<PanelBody
								title={__('Tuesday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={tuesdayStartTime}
									onChange={(value) =>
										setAttributes({
											tuesdayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={tuesdayEndTime}
									onChange={(value) =>
										setAttributes({ tuesdayEndTime: value })
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
							<PanelBody
								title={__('Wednesday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={wednesdayStartTime}
									onChange={(value) =>
										setAttributes({
											wednesdayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={wednesdayEndTime}
									onChange={(value) =>
										setAttributes({
											wednesdayEndTime: value,
										})
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
							<PanelBody
								title={__('Thursday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={thursdayStartTime}
									onChange={(value) =>
										setAttributes({
											thursdayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={thursdayEndTime}
									onChange={(value) =>
										setAttributes({
											thursdayEndTime: value,
										})
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
							<PanelBody
								title={__('Friday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={fridayStartTime}
									onChange={(value) =>
										setAttributes({
											fridayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={fridayEndTime}
									onChange={(value) =>
										setAttributes({ fridayEndTime: value })
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
							<PanelBody
								title={__('Saturday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={saturdayStartTime}
									onChange={(value) =>
										setAttributes({
											saturdayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={saturdayEndTime}
									onChange={(value) =>
										setAttributes({
											saturdayEndTime: value,
										})
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
							<PanelBody
								title={__('Sunday', 'chat-viber')}
								initialOpen={false}
							>
								<TextControl
									label={__('Start Time:', 'chat-viber')}
									value={sundayStartTime}
									onChange={(value) =>
										setAttributes({
											sundayStartTime: value,
										})
									}
									placeholder={__('00:01', 'chat-viber')}
								/>
								<TextControl
									label={__('End Time:', 'chat-viber')}
									value={sundayEndTime}
									onChange={(value) =>
										setAttributes({ sundayEndTime: value })
									}
									placeholder={__('23:59', 'chat-viber')}
								/>
							</PanelBody>
						</PanelBody>
						<PanelBody
							title={__('Appearence settings', 'chat-viber')}
							initialOpen={false}
						>
							<SelectControl
								label={__('Visibility on', 'chat-viber')}
								value={visibility}
								options={visibilityOn.map(
									({ value, label }) => ({
										value,
										label,
									})
								)}
								onChange={(newSize) => {
									setAttributes({ visibility: newSize });
								}}
							/>
							<SelectControl
								label={__('Size', 'chat-viber')}
								value={buttonSize}
								options={buttonSizeOptions.map(
									({ value, label }) => ({
										value,
										label,
									})
								)}
								onChange={(newSize) => {
									setAttributes({ buttonSize: newSize });
								}}
							/>
							<SelectControl
								label={__('Border Radius', 'chat-viber')}
								value={borderRadius}
								options={borderRadiusOptions.map(
									({ value, label }) => ({
										value,
										label,
									})
								)}
								onChange={(newSize) => {
									setAttributes({ borderRadius: newSize });
								}}
							/>
							<AlignmentToolbar
							label={__('Allignment', 'chat-viber')}
							value={textAlignment}
							onChange={onChangeAlignment}
						/>
						</PanelBody>
					</InspectorControls>
					<BlockControls>
						<AlignmentToolbar
							value={textAlignment}
							onChange={onChangeAlignment}
						/>
					</BlockControls>
					<div className={`button-wrapper vchat-editor ${textClasses}`}>
						<button
							{...useBlockProps({
								className: `avatar-active vcButtons ${classes} ${buttonSize} ${borderRadius} ${visibility}`,
							})}
							data-timezone={timeZone}
							data-btnavailablety={`{ "monday":"${mondayStartTime}-${mondayEndTime}", "tuesday":"${tuesdayStartTime}-${tuesdayEndTime}", "wednesday":"${wednesdayStartTime}-${wednesdayEndTime}", "thursday":"${thursdayStartTime}-${thursdayEndTime}", "friday":"${fridayStartTime}-${fridayEndTime}", "saturday":"${saturdayStartTime}-${saturdayEndTime}", "sunday":"${sundayStartTime}-${sundayEndTime}" }`}
						>
							<img src={imageUrl ? imageUrl : agentImage} alt="agent" />
							<div className="info-wrapper">
								<RichText
									onChange={advancedBtnInfo}
									value={info}
									placeholder={__(
										'Robert / Sales Support',
										'chat-viber'
									)}
									tagName="p"
									allowedFormats={[]}
									className="info"
								/>
								<RichText
									onChange={advancedBtnTitle}
									value={title}
									placeholder={__(
										'How can I help you?',
										'chat-viber'
									)}
									tagName="p"
									allowedFormats={[]}
									className="title"
								/>
								<RichText
								onChange={advancedBtnOnlineBadge}
									value={online}
									placeholder={__("I'm available", 'chat-viber')}
									tagName="p"
									allowedFormats={[]}
									className="online"
								/>
								<RichText
								onChange={advancedBtnOfflineBadge}
									value={offline}
									placeholder={__("I'm offline", 'chat-viber')}
									tagName="p"
									allowedFormats={[]}
									className="offline"
								/>
							</div>
						</button>
					</div>
				</>
			)}
		</>
	);
}
